<template>
  <div class="billofrights_1_page">
    <p class="big_title">{{pageTitle}}</p>
    <div class="billofrights_block" :style="{ height: imgHeight + 'px' }">
      <div class="top_block" :style="{ height: imgHeight + 'px' }">
        <img :style="{ width: imgWidth + 'px', height: imgHeight + 'px' }" src="https://resource.rcclchina.com.cn/content/brand/passenger/4-1.jpg?t=1421316917000" alt="" class="left_img">
        <img :style="{ width: (screenWidth - imgWidth) + 'px', height: imgHeight + 'px' }" src="https://resource.rcclchina.com.cn/content/brand/passenger/4.jpg?t=1421316917000" alt="" class="right_img"></div>
      <div class="bottom_block" :style="{ height: (imgHeight - 40) + 'px', left: textLeft + 'px' }">
        <perfect-scrollbar class="billofrights_text ps-container" :style="{ height: imgHeight - 60 + 'px' }">
          <user-agreement :user-agreement-type="userAgreementType" full-screen @page-load="pageLoad"></user-agreement>
        </perfect-scrollbar>
      </div>
    </div>
  </div>
</template>

<script>
import UserAgreement from '@/components/User/UserAgreement.vue';
import { PerfectScrollbar } from 'vue2-perfect-scrollbar';
import 'vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css';
import {isMobile} from "@/utilities/tools";
export default {
  name: "RewardRule",
  data () {
    return {
      pageTitle: '“皇家游享荟”项目细则与条款',
      userAgreementType: 3,
      screenWidth: 0
    }
  },
  components: {
    UserAgreement,
    PerfectScrollbar
  },
  beforeMount () {
    if(isMobile()) {
      window.location.href = `${process.env.VUE_APP_MOBILE_URL}/Rccl.UserCenter/RewardRule`;
    }
  },
  mounted() {
    this.updateScreenWidth();
    window.addEventListener('resize', this.updateScreenWidth);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateScreenWidth);
  },
  computed: {
    imgWidth() {
      return parseInt(this.screenWidth / 2);
    },
    imgHeight() {
      return parseInt(this.imgWidth / 659 * 578);
    },
    textLeft() {
      return parseInt((this.screenWidth - 700) / 2);
    }
  },
  methods: {
    updateScreenWidth() {
      this.screenWidth = document.body.clientWidth;
    },
    pageLoad(val) {
      if(val) {
        this.pageTitle = val.title;
      }
      console.log(val);
    }
  }
}
</script>

<style lang="less">
.billofrights_1_page{
  width: 100%;
  height: auto;
  overflow: hidden;
  background: #f0f0f0;
  padding: 5px 0 120px;
  & .big_title {
    width: 1000px;
    height: 50px;
    line-height: 50px;
    font-size: 32px;
    color: #478CC7;
    text-align: center;
    margin: 30px auto;
  }

  & .billofrights_block {
    width: 100%;
    height: 100%;
    position: relative;
  }

  & .top_block {
    width: 100%;
    height: 100%;
    & img {
      float: left;
    }
  }

  & .bottom_block {
    width: 700px;
    height: auto;
    overflow: hidden;
    background: #001455;
    padding: 20px 0 40px;
    position: absolute;
    top: 0;
    left: 0;
  }

  & .billofrights_text {
    width: 100%;
    height: auto;
    overflow: hidden;

    & p {
      width: 90%;
      line-height: 28px;
      font-size: 14px;
      color: #fff;
      margin: 10px auto;
      &.title {
        height: 40px;
        line-height: 40px;
        font-size: 24px;
        color: #fff;
      }
    }
  }

  & .billofrights_text ul {
    width: 80%;
    margin: 10px auto;
    font-size: 14px;
    list-style-type: disc;
  }

  & .billofrights_text ul li {
    width: 100%;
    line-height: 18px;
    color: #fff;
    list-style-type: disc;
  }

  & .billofrights_text a {
    color: #478CC7;
    font-weight: bold;
  }

  & .billofrights_text table {
    width: 80%;
    margin: 10px auto;
    border: 1px solid #fff
  }

  & .billofrights_text table tr {
    border: 1px solid #fff;
  }

  & .billofrights_text table td {
    border: 1px solid #fff;
    color: #fff;
    font-size: 14px;
    padding: 2px 0px;
  }

  & .billofrights_text p.bold {
    font-weight: bold;
  }

  & .billofrights_text p.table_title {
    text-align: center;
  }
}
</style>
<style>
.ps-container {
  width: 100%;
  height: auto;
  overflow: hidden;
}
.ps-container > .ps__rail-x {
  display: block !important;
  opacity: 1 !important;
  transition: none !important;
  -webkit-transition: none !important;
  height: 6px !important;
}
.ps-container > .ps__rail-y {
  display: block !important;
  opacity: 1 !important;
  transition: none !important;
  -webkit-transition: none !important;
  width: 6px;
}

.ps-container > .ps__rail-x > .ps__thumb-x {
  background-color: #fff;
}
.ps-container > .ps__rail-y > .ps__thumb-y {
  background-color: #fff;
  right: 0;
}

.ps-container .ps__rail-x:hover,
.ps-container .ps__rail-y:hover,
.ps-container .ps__rail-x:focus,
.ps-container .ps__rail-y:focus,
.ps-container .ps__rail-x.ps--clicking,
.ps-container .ps__rail-y.ps--clicking {
  background-color: transparent;
  opacity: 0;
}

.ps-container .ps__rail-x:hover > .ps__thumb-x,
.ps-container .ps__rail-x:focus > .ps__thumb-x,
.ps-container .ps__rail-x.ps--clicking .ps__thumb-x {
  background-color: #fff !important;
  height: 6px;
}
.ps-container .ps__rail-y:hover > .ps__thumb-y,
.ps-container .ps__rail-y:focus > .ps__thumb-y,
.ps-container .ps__rail-y.ps--clicking .ps__thumb-y {
  background-color: #fff !important;
  width: 6px;
}

.billofrights_1_page .top_block img {
  width: 49.9% !important;height: auto !important;
}
</style>